<template>
  <div id="_tlqn_member_sample_list" class="row no-wrap full-width q-my-xs">
    <q-item
      class="shadow-2 rounded-borders q-pa-sm q-mr-xs col-10 column"
      :to="{
        name: 'member-sample-detail',
        params: {
          sample_id: sample.id,
        },
      }"
    >
      <div class="row no-wrap justify-between items-center q-px-md">
        <div id="_tlqn_member_metadata">
          <p
            class="
              text-subtitle1 text-bold
              ellipsis
              text-no-wrap
              q-pa-none q-ma-none
            "
            style="max-width: 260px"
          >
            {{ sample.detail.name }}
            <q-tooltip>
              {{ sample.detail.name }}
            </q-tooltip>
          </p>
          <p class="text-caption text-no-wrap ellipsis q-pa-none q-ma-none">
            {{ sample.detail.sample_id }}
          </p>
        </div>

        <p
          v-if="sample.sample_status != 3 && sample.sample_status != 4"
          style="font-size: 1.2rem"
          class="q-ma-none q-mr-md text-bold text-primary"
        >
          {{ (sample.process * 100).toFixed(1) + "%" }}
        </p>
      </div>
      <div class="q-px-md">
        <q-chip
          v-for="(label, index) in sample.labels"
          :key="index"
          class="text-caption bg-primary text-white"
          dense
          >{{ label.description }}
        </q-chip>
        <q-chip class="text-caption bg-primary text-white" dense
          >{{ this.sampleStatusDict[sample.sample_status].description }}
        </q-chip>
      </div>
      <!-- <line-progress /> -->
    </q-item>

    <div
      class="
        column
        justify-center
        items-center
        rounded-borders
        shadow-2
        col-2
        q-pa-sm q-ml-xs
      "
      @click="showTips = true"
    >
      <q-icon
        class="q-pb-sm"
        :name="`fas ${sampleStatusDict[sample.sample_status].icon}`"
        size="1.5rem"
        :style="'color: ' + sampleStatusDict[sample.sample_status].color"
      />
      <p
        class="q-ma-none text-bold "
        :style=" `color: ${sampleStatusDict[sample.sample_status].color}`"
        style="font-size: 0.8rem"
      >
        {{ sampleStatusDict[sample.sample_status].description }}
      </p>

      <q-dialog v-model="showTips">
        <q-card class="" style="width: 300px">
          <q-card-section :style="`background-color: ${sampleStatusDict[sample.sample_status].color}`">
            <div class="text-subtitle1 text-white text-bold">样本状态</div>
          </q-card-section>
          <q-card-section>
            <strong>样本：{{ sample.detail.name }}</strong
            ><br />
            <br />
            {{ sampleStatusDict[sample.sample_status].tooltip }}
          </q-card-section>
        </q-card>
      </q-dialog>
      <q-tooltip>
        {{ sampleStatusDict[sample.sample_status].tooltip }}
      </q-tooltip>
    </div>
  </div>
</template>

<script>
import SampleStatusMixin from "@/mixins/sample-status.mixin";
export default {
  mixins: [SampleStatusMixin],
  components: {
    LineProgress: () =>
      import("../../../components/progress-bar/LineProgress.vue"),
  },
  data() {
    return {
      showTips: false,
      // sampleStatusDict[sample.sample_status]: {
      //   des: "",
      //   color: "",
      //   icon: "",
      //   tooltip: "",
      // },
    };
  },
  props: {
    sample: {
      type: Object,
    },
  },

  // watch: {
  //   sample: {
  //     immediate: true,
  //     handler(sample) {
  //       if (!sample) return;
  //       const { sampleStatusDict[sample.sample_status] } = this;
  //       switch (sample.sample_status) {
  //         case 0:
  //           sampleStatusDict[sample.sample_status].des = "完成";
  //           sampleStatusDict[sample.sample_status].tooltip = "样本已完成并提交，如需修改请联系管理员";
  //           sampleStatusDict[sample.sample_status].color = "green-8";
  //           sampleStatusDict[sample.sample_status].icon = "fa-clipboard-check";
  //           break;
  //         case 1:
  //           sampleStatusDict[sample.sample_status].des = "未开始";
  //           sampleStatusDict[sample.sample_status].tooltip = "还未开始调查";
  //           sampleStatusDict[sample.sample_status].color = "blue-8";
  //           sampleStatusDict[sample.sample_status].icon = "fa-satellite-dish";
  //           break;
  //         case 2:
  //           sampleStatusDict[sample.sample_status].des = "进行中";
  //           sampleStatusDict[sample.sample_status].tooltip = "调查进行中";
  //           sampleStatusDict[sample.sample_status].color = "green-6";
  //           sampleStatusDict[sample.sample_status].icon = "fa-book-reader";
  //           break;
  //         case 3:
  //           sampleStatusDict[sample.sample_status].des = "样本拒访";
  //           sampleStatusDict[sample.sample_status].tooltip =
  //             "样本已拒访并且样本已提交，如需修改请联系管理员";
  //           sampleStatusDict[sample.sample_status].color = "deep-orange-9";
  //           sampleStatusDict[sample.sample_status].icon = "fa-comment-slash";
  //           break;
  //         case 4:
  //           sampleStatusDict[sample.sample_status].des = "无效样本";
  //           sampleStatusDict[sample.sample_status].tooltip =
  //             "样本无法找到且样本已提交，如需修改请联系管理员";
  //           sampleStatusDict[sample.sample_status].color = "blue-grey-10";
  //           sampleStatusDict[sample.sample_status].icon = "fa-cat";
  //           break;
  //       }
  //     },
  //   },
  // },
};
</script>

<style lang="scss"></style>
